var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "bs-temp clearfix"
  }, [_vm.footer ? _vm._m(0) : _vm._e()]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('footer', {
    attrs: {
      "id": "footer--rn"
    }
  }, [_c('Reinsurance', {
    attrs: {
      "is-scramble-link": _vm.isCurrentRouteNeedsSEOOptimisation
    }
  }), _vm._v(" "), _c('LinksNewsletter', {
    attrs: {
      "content": _vm.footer,
      "is-scramble-link": _vm.isCurrentRouteNeedsSEOOptimisation
    }
  }), _vm._v(" "), _c('PaymentSocials', {
    attrs: {
      "content": _vm.footer,
      "is-scramble-link": _vm.isCurrentRouteNeedsSEOOptimisation
    }
  }), _vm._v(" "), _c('MentionsLanguage', {
    attrs: {
      "is-scramble-link": _vm.isCurrentRouteNeedsSEOOptimisation
    }
  })], 1);
}];
export { render, staticRenderFns };